import { memo } from 'react';
import classNames from 'classnames';
import Image from 'components/Image';
import styles from './EffectBadge.module.scss';

const EffectBadge = memo(function ({ badgeImageUrl, effect, onPdp }) {
  return badgeImageUrl ? (
    <div
      className={classNames('position-absolute', styles.badge, {
        [styles.pdp]: onPdp,
      })}
    >
      <div className={classNames('position-relative', styles.inner)}>
        <Image
          fill
          alt={`Badge for ${effect} effect`}
          className={styles.image}
          data-value="effect-badge-image"
          sizes="(min-width: 992px) 10vw, 20vw"
          src={badgeImageUrl}
        />
      </div>
    </div>
  ) : null;
});

export default EffectBadge;
